var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.target,
        title: "Dépannage",
        scrollable: "",
        "hide-footer": "",
        size: "lg",
      },
    },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-md-center pb-md-3" },
        [
          _c(
            "b-col",
            { staticClass: "text-center", attrs: { "align-self": "center" } },
            [
              _vm._v(
                "\n      Dépanner le " +
                  _vm._s(_vm.getTroubleType()) +
                  " : " +
                  _vm._s(_vm.label) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("list-devices", {
        attrs: { devices: _vm.devices, full: false },
        on: { fix: _vm.callFix },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }